import { render, staticRenderFns } from "./ReadAloud.vue?vue&type=template&id=35ed659a&scoped=true&"
import script from "./ReadAloud.vue?vue&type=script&lang=js&"
export * from "./ReadAloud.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloud.vue?vue&type=style&index=0&id=35ed659a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed659a",
  null
  
)

export default component.exports